import { ReactComponent as CircleDotRegularIcon } from "../assets/icons/circle-dot-regular.svg";
import { ReactComponent as CircleRegularIcon } from "../assets/icons/circle-regular.svg";

type TRadioComponentProps = {
  isSelected: boolean;
  labelClassName: string;
  label: string;
  onClick: (label: string) => void;
};

const RadioComponent = ({
  isSelected,
  labelClassName,
  label,
  onClick,
}: TRadioComponentProps) => {
  return (
    <div
      className={`flex flex-row items-center px-14 py-4 space-x-12 cursor-pointer`}
      onClick={() => onClick(label)}
    >
      <div>
        {isSelected ? (
          <CircleDotRegularIcon className="w-16 h-16 text-darwin-primary-500" />
        ) : (
          <CircleRegularIcon className="w-16 h-16 text-darwin-primary-500" />
        )}
      </div>
      <div className={labelClassName}>{label}</div>
    </div>
  );
};

export default RadioComponent;
